// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"d126dac1a2de1b3f080a","691":"c1bf5d17b2506cb65e95"}[chunkId] + ".js";
};